// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_ny-5";
export var filledCircle = "_ny-4";
export var historyEntry = "_ny-3";
export var messageSideLeft = "_ny-1";
export var messageSideRight = "_ny-2";
export var orderTrackingCarouselWrapper = "_ny-6";
export var orderTrackingInfoContainer = "_ny-0";